
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotion/promotion_first_day",
      function () {
        return require("private-next-pages/promotion/promotion_first_day.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotion/promotion_first_day"])
      });
    }
  